import(/* webpackMode: "eager" */ "/opt/apps/wisprs/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/apps/wisprs/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/opt/apps/wisprs/src/components/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ArticleMarkdown"] */ "/opt/apps/wisprs/src/components/markdown-view.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navigation"] */ "/opt/apps/wisprs/src/components/navigation.tsx");
